"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
exports.artifactType = 'fundingApprovalReport';
// Zod schema and new config type
exports.NodeConfigSchema = zod_1.z
    .object({
    verificationReportSlug: zod_1.z
        .string()
        .describe('Slug pointing to the corresponding verification report'),
})
    .describe('Configuration for fundingApprovalReport node');
// Zod schema and new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.null(),
    creditFacilitySlug: zod_1.z.string(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map